// Capture marketing attribution (UTM params + referrer) on first visit and persist it.
import { safeGet, safeSet } from "@/lib/storage";
import { logger } from "@/lib/logger";

const KEY = "autobus_attribution";

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
    };
    const hasUtm = utm.utm_source || utm.utm_medium || utm.utm_campaign;
    const existing = getAttribution();
    if (hasUtm || !existing) {
      const data = {
        ...utm,
        referrer: document.referrer && !document.referrer.includes(window.location.host)
          ? document.referrer
          : existing?.referrer || null,
      };
      safeSet(KEY, JSON.stringify(data));
    }
  } catch (e) {
    logger.warn("Attribution capture failed:", e);
  }
}

export function getAttribution() {
  try {
    const raw = safeGet(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    logger.warn("Attribution parse failed:", e);
    return null;
  }
}
